import React from 'react';
import { Navigate } from 'react-router-dom';
import useRouteAuthorization from '../hooks/useRouteAuthorization';
import { CircularProgress, Box } from '@mui/material';

/**
 * Componente que protege las rutas validando si el usuario tiene acceso
 * según los menús permitidos que devuelve el backend.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componente hijo a renderizar si está autorizado
 * @returns {React.ReactNode}
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthorized, isChecking } = useRouteAuthorization();

  // Validar si hay sesión activa
  const usuarioData = window.sessionStorage.getItem('usuario');

  if (!usuarioData) {
    // Si no hay usuario autenticado, redirigir a login
    return <Navigate to="/" replace />;
  }

  // Mostrar loader mientras se valida la autorización
  if (isChecking) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Si está autorizado, renderizar el componente hijo
  // Si no está autorizado, useRouteAuthorization ya redirigió a /auth/unauthorized
  return isAuthorized ? children : null;
};

export default ProtectedRoute;
